export const Modal = {
    Confirmacao: {
        larguraMinima: 250,
        larguraMaxima: 450
    },
    Prompt: {
        larguraMinima: 250,
        larguraMaxima: 600
    },
    Processamento: {
        larguraMinima: 600,
        larguraMaxima: 800
    }
}